module.exports = __webpack_public_path__ + "img/blue.b8ab30d.svg";